module.exports = __webpack_public_path__ + "media/images/slide_3-371165de142457bd2b757000a69a6907.png";